module.exports = __webpack_public_path__ + "RMR Formulario de Reclamación.pdf";